<template>
  <div class="container_self">
    <h3>添加JSON文件</h3>

    <el-form
      size="mini"
      :model="addJsonForm"
      label-width="140px"
      :rules="rules"
      ref="ruleForm"
      class="adsForm"
    >
      <div class="form-column">
        <el-form-item label="文件">
          <input type="file" @change="handleFileUpload" accept=".xlsx, .xls" />
        </el-form-item>
        <el-form-item label="域名" prop="domain">
          <el-input
            type="text"
            v-model="addJsonForm.domain"
            placeholder="请填写域名"
          ></el-input>
        </el-form-item>
        <el-form-item label="GAID" prop="gaID">
          <el-input
            type="text"
            v-model="addJsonForm.gaID"
            placeholder="请填写GAID"
          ></el-input>
        </el-form-item>
        <el-form-item label="站点类型" prop="type">
          <el-select v-model="addJsonForm.websiteType">
            <el-option value="game" label="游戏"></el-option>
            <el-option value="info" label="资讯"></el-option>
            <el-option value="movie" label="视频"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道" prop="channelID">
          <el-select
            v-model="addJsonForm.channelID"
            placeholder="请选择渠道"
            @change="choseChannel"
          >
            <el-option
              v-for="(item, index) in options"
              :value="item.code"
              :label="item.label"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否开启锚定广告">
          <el-radio v-model="addJsonForm.bottomAnchorFlag" :label="true">是</el-radio>
          <el-radio v-model="addJsonForm.bottomAnchorFlag" :label="false">否</el-radio>
        </el-form-item>
        <el-form-item label="锚定广告代码" v-if="addJsonForm.bottomAnchorFlag">
          <el-input
            type="text"
            v-model="addJsonForm.adxBottomAnchorAdUnit"
            placeholder="请填写锚定广告代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否开启穿插广告">
          <el-radio v-model="addJsonForm.adxInterstitialFlag" :label="true">是</el-radio>
          <el-radio v-model="addJsonForm.adxInterstitialFlag" :label="false">否</el-radio>
        </el-form-item>
        <el-form-item label="穿插广告代码" v-if="addJsonForm.adxInterstitialFlag">
          <el-input
            type="text"
            v-model="addJsonForm.adxInterstitialAdUnit"
            placeholder="请填写穿插广告代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="vast链接">
          <el-input
            type="text"
            v-model="addJsonForm.vastTag"
            placeholder="请填写vast链接"
          ></el-input>
        </el-form-item>
        <el-form-item label="激励广告">
          <el-input
            type="text"
            v-model="addJsonForm.awardUnit"
            placeholder="请填写激励视频广告"
          ></el-input>
        </el-form-item>
      </div>
      <div class="form-column" style="margin-left: 10%">
        <el-form-item label="首页广告一代码" prop="contentAds[0].adUnit">
          <el-input
            type="text"
            v-model="addJsonForm.contentAds[0].adUnit"
            placeholder="请填写首页广告一代码"
          ></el-input>
        </el-form-item>
        <el-form-item label="首页广告一尺寸">
          <el-select v-model="addJsonForm.contentAds[0].size" placeholder="选择首页广告一尺寸">
            <el-option
              v-for="(tpl, index) in sizes"
              :value="tpl.size"
              :label="tpl.label"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首页广告一unitId" prop="contentAds[0].unitId">
          <el-input
            type="text"
            v-model="addJsonForm.contentAds[0].unitId"
            placeholder="请填写首页广告一unitId"
          ></el-input>
        </el-form-item>
        <el-form-item label="首页广告二代码"  prop="contentAds[1].adUnit">
          <el-input
            type="text"
            v-model="addJsonForm.contentAds[1].adUnit"
            placeholder="请填写首页广告二代码"

          ></el-input>
        </el-form-item>
        <el-form-item label="首页广告二尺寸">
          <el-select v-model="addJsonForm.contentAds[1].size">
            <el-option
              v-for="(tpl, index) in sizes"
              :value="tpl.size"
              :label="tpl.label"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首页广告二unitId" prop="contentAds[1].unitId">
          <el-input
            type="text"
            v-model="addJsonForm.contentAds[1].unitId"
            placeholder="请填写首页广告二unitId"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 140px; text-align: center">
          <el-button size="medium" @click="resetForm('ruleForm')">取消</el-button>
          <el-button type="success" size="medium" @click="submitFrom('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn";
import * as XLSX from "xlsx";
export default {
  data() {
    return {
      addJsonForm: {
        adxBottomAnchorAdUnit: "",
        adxInterstitialAdUnit: "",
        adxInterstitialFlag: true,
        adxOrAdsFlag: true,
        bottomAnchorFlag: true,
        channelID: "",
        collectDataFlag: true,
        contentAds: [
          {
            adUnit: "",
            arrowDown:1,
            arrowUp: 1,
            size: [300,250],
            unitId: "",
          },
          {
            adUnit: "",
            arrowDown: 1,
            arrowUp: 1,
            size: [300,250],
            unitId: "",
          }
        ],
        domain: "",
        gaID: "",
        pageGlobalConfig: {
          color: "",
          copyright: "",
          lightColor: "",
        },
        vastTag:"",
        awardUnit:"",
        slotAccount: "",
        slotChannelTag: "",
        topAnchorFlag: true,
        websiteType: "",
        editJson: "",
      },
      rules: {
        domain: [{ required: true, message: "请输入域名", trigger: "blur" }],
        gaID: [{ required: true, message: "请输入GAID", trigger: "blur" }],
        "contentAds[0].adUnit": [
          { required: true, message: "请输入首页广告一代码", trigger: "blur" },
        ],
        "contentAds[0].unitId": [
          { required: true, message: "请输入首页广告一unitId", trigger: "blur" },
        ],
        "contentAds[1].adUnit": [
          { required: true, message: "请输入首页广告二代码", trigger: "blur" },
        ],
        "contentAds[1].unitId": [
          { required: true, message: "请输入首页广告二unitId", trigger: "blur" },
        ],
        "list[0].adUnit": [
          { required: true, message: "请输入详情页广告代码", trigger: "blur" },
        ],
        "list[0].unitId": [
          { required: true, message: "请输入详情页广告unitId", trigger: "blur" },
        ],
        "history[0].adUnit": [
          { required: true, message: "请输入列类别广告代码", trigger: "blur" },
        ],
        "history[0].unitId": [
          { required: true, message: "请输入类别广告unitId", trigger: "blur" },
        ],
      },
      options: require("@/assets/networkcode.json"),
      sizes: require("@/assets/size.json"),
    };
  },
  methods: {
    choseChannel(item) {
      // console.log(item);
      this.options.forEach((element) => {
        // console.log(element);
        if (item === element.code) {

          this.addJsonForm.slotAccount = element.slot_account;
          this.addJsonForm.channelID = element.code;
          this.addJsonForm.slotChannelTag = element.slot_channel_tag;
        }
      });
    },
    async submitFrom(formName) {
      const valid = await new Promise((resolve) => {
        this.$refs[formName].validate((valid) => {
          resolve(valid);
        });
      });
      if (valid) {
        this.addJsonForm.pageGlobalConfig.copyright =
          "©2023 - 2024 " + this.addJsonForm.domain + ". All Rights Reserved.";
        this.addJsonForm.pageGlobalConfig.color = ``;
        this.addJsonForm.pageGlobalConfig.lightColor = ``;
        // console.log("size1",this.addJsonForm.contentAds[0].size[1])
        if(this.addJsonForm.contentAds[0].size[1]==50){
          this.addJsonForm.contentAds[0].arrowDown=2;
          this.addJsonForm.contentAds[0].arrowUp=2;
        }
        if(this.addJsonForm.contentAds[1].size[1]==50){
          this.addJsonForm.contentAds[1].arrowDown=2;
          this.addJsonForm.contentAds[1].arrowUp=2;
        }
        console.log(this.addJsonForm);
        axiosPost("/api/ad_json_file/add", this.addJsonForm, "JSON").then((res) => {
          if (res.code == 0) {
            this.$message({ message: "JSON文件添加成功", type: "success" });
            this.resetForm("ruleForm");
            sessionStorage.removeItem("editJson");
          }
        });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields(); // 重置表单
      this.addJsonForm = {
        adxBottomAnchorAdUnit: "",
        adxInterstitialAdUnit: "",
        adxInterstitialFlag: true,
        adxOrAdsFlag: true,
        bottomAnchorFlag: true,
        channelID: "",
        collectDataFlag: true,
        contentAds: [
          {
            adUnit: "",
            arrowDown: 1,
            arrowUp: 1,
            size: [],
            unitId: "",
          },
          {
            adUnit: "",
            arrowDown: 1,
            arrowUp: 1,
            size: [],
            unitId: "",
          }
        ],
        domain: "",
        gaID: "",
        vastTag:"",
        awardUnit:"",
        pageGlobalConfig: {
          color: "",
          copyright: "",
          lightColor: "",
        },
        slotAccount: "",
        slotChannelTag: "",
        topAnchorFlag: true,
        websiteType: "",
      };
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // 只处理第一个工作表
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // 将工作表转换为 JSON 格式
        let result = XLSX.utils.sheet_to_json(worksheet);
        this.addJsonForm.domain=(result[0].dm).trim();
        if(result[0].dm.includes('game')){
          this.addJsonForm.websiteType="game";
        }
        //获取GA
         axiosGet('/api/domains/list',{keyword:(result[0].dm).trim()}).then(res=>{
          if(res.code==0){
            if(res.data.records){
              this.addJsonForm.gaID=res.data.records[0].measurementId;
            }
          }
         })
        let channelId = result[0].code.match(/\/(\d+)\//)[1];
        this.choseChannel(channelId);
        this.addJsonForm.channelID=channelId;
        // this.addJsonForm.slotAccount
        const regex = /id=['"]?(div-gpt-ad-\d+)['"]?/;
          const regexCustom = /\/([A-Z]+\/)/;
          let prvString = result[0].code.match(regexCustom)
            ? result[0].code.match(regexCustom)[1]
            : "";
        result.forEach(item=>{
          if(item.name=="前贴"){
            this.addJsonForm.vastTag=item.code;
            this.addJsonForm.websiteType="movie";
          }
          if(item.size=="锚定"||item.size=="底部锚定"){
            this.addJsonForm.adxBottomAnchorAdUnit=prvString+item.adUnit;
          }
          if(item.size=="穿插"){
            this.addJsonForm.adxInterstitialAdUnit=prvString+item.adUnit;
          }
          if(item.size=="激励"){
            this.addJsonForm.awardUnit=prvString+item.adUnit;
          }
          if(item.adUnit.includes('_homeup')){
            this.addJsonForm.contentAds[0].adUnit=item.adUnit;
            this.addJsonForm.contentAds[0].size=item.size.split('x');
            this.addJsonForm.contentAds[0].unitId=item.code.match(regex)[1];
          }
          if(item.adUnit.includes('_homedown')){
            this.addJsonForm.contentAds[1].adUnit=item.adUnit;
            this.addJsonForm.contentAds[1].size=item.size.split('x');
            this.addJsonForm.contentAds[1].unitId=item.code.match(regex)[1];
          }
        })
        // if (result[0][5] === "穿插") {
        //   let channelId = result[0][7].match(/\/(\d+)\//)[1];
        //   const regexCustom = /\/([A-Z]+\/)/;
        //   let prvString = result[0][7].match(regexCustom)
        //     ? result[0][7].match(regexCustom)[1]
        //     : "";
        //   this.addJsonForm = {
        //     adxBottomAnchorAdUnit: prvString + result[1][6],
        //     adxInterstitialAdUnit: prvString + result[0][6],
        //     adxInterstitialFlag: true,
        //     adxOrAdsFlag: true,
        //     bottomAnchorFlag: true,
        //     channelID: channelId,
        //     collectDataFlag: true,
        //     domain: result[0][4],
        //     gaID: "",
        //     index: [
        //       {
        //         adUnit: prvString + result[2][6],
        //         size: [300, 250],
        //         unitId: result[2][7].match(/id='(div-gpt-ad-\d+-\d+)'/)[1],
        //       },
        //       {
        //         adUnit: prvString + result[3][6],
        //         size: [300, 250],
        //         unitId: result[3][7].match(/id='(div-gpt-ad-\d+-\d+)'/)[1],
        //       },
        //     ],
        //     history: [
        //       {
        //         adUnit: prvString + result[4][6],
        //         size: [300, 250],
        //         unitId: result[4][7].match(/id='(div-gpt-ad-\d+-\d+)'/)[1],
        //       },
        //     ],
        //     detail: [
        //       {
        //         adUnit: prvString + result[5][6],
        //         size: [300, 250],
        //         unitId: result[5][7].match(/id='(div-gpt-ad-\d+-\d+)'/)[1],
        //       },
        //     ],
        //     srch: [
        //       {
        //         adUnit: prvString + result[4][6],
        //         size: [300, 250],
        //         unitId: result[4][7].match(/id='(div-gpt-ad-\d+-\d+)'/)[1],
        //       },
        //     ],
        //     list: [
        //       {
        //         adUnit: prvString + result[4][6],
        //         size: [300, 250],
        //         unitId: result[4][7].match(/id='(div-gpt-ad-\d+-\d+)'/)[1],
        //       },
        //     ],
        //     pageGlobalConfig: {
        //       color: "",
        //       copyright: "",
        //       lightColor: "",
        //     },
        //     slotAccount: "",
        //     slotChannelTag: "",
        //     topAnchorFlag: true,
        //     websiteType:
        //       result[0][4].includes("info") || result[0][4].includes("info")
        //         ? "info"
        //         : "game",
        //   };

        //   this.choseChannel(channelId);
        // } else {
        //   let channelId = result[0][6].match(/\/(\d+)\//)[1];
        //   // 使用正则表达式提取ID
        //   const regex = /id=['"]?(div-gpt-ad-\d+)['"]?/;
        //   const regexCustom = /\/([A-Z]+\/)/;
        //   let prvString = result[0][6].match(regexCustom)
        //     ? result[0][6].match(regexCustom)[1]
        //     : "";
        //   this.addJsonForm = {
        //     adxBottomAnchorAdUnit: prvString + result[4][5],
        //     adxInterstitialAdUnit: prvString + result[5][5],
        //     adxInterstitialFlag: true,
        //     adxOrAdsFlag: true,
        //     bottomAnchorFlag: true,
        //     channelID: channelId,
        //     collectDataFlag: true,
        //     domain: result[0][3],
        //     gaID: result[0][8],
        //     index: [
        //       {
        //         adUnit: prvString + result[0][5],
        //         size: [300, 250],
        //         unitId: result[0][6].match(regex)[1],
        //       },
        //       {
        //         adUnit: prvString + result[1][5],
        //         size: [300, 250],
        //         unitId: result[1][6].match(regex)[1],
        //       },
        //     ],
        //     history: [
        //       {
        //         adUnit: prvString + result[2][5],
        //         size: [300, 250],
        //         unitId: result[2][6].match(regex)[1],
        //       },
        //     ],
        //     detail: [
        //       {
        //         adUnit: prvString + result[3][5],
        //         size: [300, 250],
        //         unitId: result[3][6].match(regex)[1],
        //       },
        //     ],
        //     srch: [
        //       {
        //         adUnit: prvString + result[2][5],
        //         size: [300, 250],
        //         unitId: result[2][6].match(regex)[1],
        //       },
        //     ],
        //     list: [
        //       {
        //         adUnit: prvString + result[2][5],
        //         size: [300, 250],
        //         unitId: result[2][6].match(regex)[1],
        //       },
        //     ],
        //     pageGlobalConfig: {
        //       color: "",
        //       copyright: "",
        //       lightColor: "",
        //     },
        //     slotAccount: "",
        //     slotChannelTag: "",
        //     topAnchorFlag: true,
        //     websiteType:
        //       result[0][5].includes("info") || result[0][5].includes("info")
        //         ? "info"
        //         : "game",
        //   };

        //   this.choseChannel(channelId);
        // }
      };

      reader.readAsArrayBuffer(file);
    },
  },
  mounted() {
    let isEdit = sessionStorage.getItem("editJson");
    if (isEdit) {
      this.addJsonForm = JSON.parse(isEdit);
    }
  },
  destroyed() {
    sessionStorage.removeItem('editJson');
  },
};
</script>

<style scoped>
.adsForm {
  width: 100%;
  display: flex;
  align-items: top;
}
.form-column {
  width: 40%;
}
</style>



// WEBPACK FOOTER //
// src/components/view/JsonManager/addJson.vue